// extracted by mini-css-extract-plugin
export default {"checklist":"CheckList_checklist__QNxIm","checkbox":"CheckList_checkbox__t6j-r","content":"CheckList_content__Zk5G+"};